module.exports = __webpack_public_path__ + "img/topbg.7d998b9c.png";